// extracted by mini-css-extract-plugin
export default {"modal":"SimpleModal_modal__b+Asj","active":"SimpleModal_active__Cvtu6","overlay":"SimpleModal_overlay__kfMH5"};